module.exports = __webpack_public_path__ + "media/images/arrow-22ce4e6412713c95684ce8d8026043f8.svg";